module.exports = __webpack_public_path__ + "static/footer-btn.a4337b75.png";